<template>
  <div>
    <div class="top_div">
      <img class="home_banner" src="../../../static/img/物业banner.png" />
    </div>
    <div class="top_item_div">
      <div class="top_item">
        <img src="../../../static/img/物业icon.png" />
        <p class="title">物业管理服务</p>
      </div>

      <div class="heading_div">
        <p class="heading">物业管理服务</p>
        <p class="tv_content">
          宁波宏邦保安服务有限公司主要承接餐饮管理、保安服务、日常保洁等专项服务及托管服务。凭借专业的服务资质和经验秉承细心、贴心的服务理念，不断提升物业服务质量，向国际物业管理服务标准看齐，为每一位业主提供细致周到的服务。
        </p>
      </div>
    </div>

    <div class="icon_div">
      <div class="icon_item">
        <img src="../../../static/img/物业icon1.png" />
        <p>细心</p>
      </div>
      <div class="icon_item">
        <img src="../../../static/img/物业icon2.png" />
        <p>贴心</p>
      </div>
      <div class="icon_item">
        <img src="../../../static/img/物业icon3.png" />
        <p>用心</p>
      </div>
      <div class="icon_item">
        <img src="../../../static/img/物业icon4.png" />
        <p>真心</p>
      </div>
      <div class="icon_item">
        <img src="../../../static/img/物业icon5.png" />
        <p>诚心</p>
      </div>
    </div>

    <div class="honor_div">
      <p>客户为先 专业为本 服务至上</p>
      <div class="honor_sub">
        <serviceListView></serviceListView>
      </div>
    </div>
    <div class="honor_div2">
      <p>15年服务经验集成 24小时管家式服务</p>
      <p class="content">
        宁波宏邦保安服务有限公司主要承接餐饮管理、保安服务、日常保洁等专项服务及托管服务。凭借专业的服务资质和经验秉承细心、贴心的服务理念，不断提升物业服务质量，向国际物业管理服务标准看齐，为每一位业主提供细致周到的服务。
      </p>
      <div class="honor_sub">
        <serviceMidView></serviceMidView>
      </div>
    </div>
    <div class="honor_div">
      <p>设备运维服务</p>
      <p class="content">
        根据客户需求，基于以设备运维平台为核心载体的设备运维标准体系，为客户提供针对性的智慧，高效，专业的平台运维，实现设备全生命周期一体化优质服务，
        提升设备可使用价值。
      </p>
      <div class="honor_sub">
        <serviceView></serviceView>
      </div>
    </div>
    <div class="honor_div2">
      <p>房屋租赁</p>
      <p class="content">
        致力于提供便捷、舒适、安全、好玩的居住空间，公寓内设立公共客厅、公共活动室、多功能影音室等共享空间，提供包括便利店、健身房、停车场等综合便捷的生活配套，打造生态化的全能生活社区。
      </p>
      <div class="honor_sub">
        <div class="service_bottom_div">
          <div class="service_bottom_item">
            <img src="../../../static/img/房屋租赁1.png" />
            <div class="service_tv">
              <p class="title">一站式业态融合</p>
              <p class="title">一站式生活服务</p>
              <p class="content">
                与办公、酒店、医疗、教育、影业、文化等产业融合时尚共享公区、完善社区服务
              </p>
            </div>
          </div>
           <div class="service_bottom_item">
            <img src="../../../static/img/房屋租赁2.png" />
            <div class="service_tv">
              <p class="title">智慧物业、智慧安防、智慧家居</p>
              <p class="title">&emsp;</p>
              <p class="content">
                覆盖硬件设施层、软件服务层、公寓生态层的科技社区
              </p>
            </div>
          </div>
           <div class="service_bottom_item">
            <img src="../../../static/img/房屋租赁3.png" />
            <div class="service_tv">
              <p class="title">高素质、高活力、高服务意识</p>
              <p class="title">的管家团队</p>
              <p class="content">
                尊重独处、引导相识、提供共享的伙伴式服务
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import serviceView from "../view/ServiceView.vue";
import serviceListView from "../view/ServiceListView.vue";
import serviceMidView from "../view/ServiceCenterView.vue";

export default {
  components: {
    serviceView,
    serviceListView,
    serviceMidView,
  },
  data() {
    return {
      Detail: [],
    };
  },
  mounted() {
    this.Init();
  },
  destroyed() {},
  deactivated() {
    this.$destroy();
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.Init();
    },
  },
  methods: {
    Init() {
      this.getDetail();
    },
    navto(path) {
      // $(".collapse.in").removeClass("in");
      this.$router.push(path);
    },
    getDetail() {
      this.$axios.get("api/contacts/company").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.Detail = response.data.data;
          }
        }.bind(this)
      );
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleScroll() {
      $(".num").waypoint(
        () => {
          this.$refs.mynum1.start();
        },
        {
          offset: "80%",
        }
      );
      $(".mynum").waypoint(
        () => {
          this.$refs.mynum.start();
        },
        {
          offset: "80%",
        }
      );
    },
  },
};
</script>
<style lang="stylus" scoped>
.top_div {
  height: 68.5rem;
  width: 100%;
  z-index: -1;
  position: relative;
}

.home_banner {
  width: 100%;
  height: 100%;
  object-fit: cover;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: var(--textBlue);

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.top_item_div {
  width: 100%;
  padding: 0 44rem;
  display: flex;
  justify-content: center;
  margin-top: -10rem;
  z-index: 1;
}

.top_item {
  background: var(--textBlue);
  width: 49rem;
  height: 33rem;
  align-content: center;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.2);
  color: white;

  img {
    margin: 5rem 0;
  }

  .title {
    font-size: 3.5rem;
    font-family: regular;
  }
}

.heading_div {
  margin: 15rem 0 0 10rem;
  width: 63rem;
}

.heading {
  font-size: 3rem;
  color: var(--textBlack);
  text-align: left;
  font-family: regular;
}

.tv_content {
  font-size: 1.8rem;
  color: var(--textBlack);
  text-align: justify;
  font-family: light;
}

.icon_div {
  display: flex;
  color: var(--textGary80);
  font-size: 1.8rem;
  justify-content: space-evenly;
  margin: 8rem 35rem 14rem;

  .icon_item {
    background-image: url('../../../static/img/icon_bg.png');
    width: 18rem;
    height: 18rem;
  }

  img {
    width: 5rem;
    height: 5rem;
    margin: 4rem auto 1rem;
  }
}

.honor_div {
  background: var(--divGaryE250);
  padding: 10rem 40rem;
  color: var(--textBlue);
  font-size: 3.4rem;
  font-family: regular;

  p {
    margin: 0 0 5rem;
  }

  .content {
    font-size: 1.8rem;
    color: var(--textBlack);
    font-family: light;
    padding: 0 20rem;
    margin: 0;
  }

  .honor_sub {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .img1 {
    width: 29rem;
    height: 40rem;
  }

  .img2 {
    width: 36rem;
    height: 28rem;
  }
}

.honor_div2 {
  background: white;
  padding: 10rem 15%;
  color: var(--textBlue);
  font-size: 3.4rem;
  font-family: regular;

  p {
    margin: 0 0 3rem;
  }

  .content {
    font-size: 1.8rem;
    color: var(--textBlack);
    font-family: light;
    padding: 0 20rem;
    margin: 0;
  }

  .honor_sub {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .img1 {
    width: 29rem;
    height: 40rem;
  }

  .img2 {
    width: 36rem;
    height: 28rem;
  }
}

.service_bottom_div {
  margin:5rem 0 10rem;
  width:100%;
  display: flex;
  justify-content: space-evenly;
  flex-wrap:wrap;

  img{
    width:35rem;
    height:30rem;
    object-fit :contain;
  }

  .service_bottom_item {
    // background-image:url('../../../static/img/房屋租赁1.png')
    position: relative;
  }

  .service_tv {
    position: absolute;
    top: 40%;
    padding: 0 5rem;
  }

  .title {
    text-align: center;
    font-size: 1.7rem;
    font-family: medium;
    margin: 0;
  }

  .content {
    margin:3rem 0;
    padding:0;
    text-align: left;
    font-size: 1.6rem;
    font-family: regular;
  }
}

@media screen and (max-width: 800px) {
  .top_item_div {
    padding: 0 1rem;
  }

  .top_item {
    height: 25rem;

    img {
      width: 5rem;
      // margin:2rem;
    }
  }

  .heading_div {
    margin-left: 5rem;
  }

  .icon_div {
    margin: 1rem;
  }

  .honor_div {
    padding: 3rem 1rem;
    .content{
      padding:0 1rem;
    }
  }

  .honor_div2 {
    padding: 3rem 1rem;
    .content{
      padding:0 1rem;
    }
  }
  .honor_div .honor_sub{
    div{
      margin:auto;
    }
  }
  .service_bottom_div {
    .service_bottom_item{
      // width:100%;
    }
  img{
    width:100%;
    height:40rem;
    object-fit :contain;
  }
  }
}
</style>